module.exports = __webpack_public_path__ + "img/BAU_Partners_2.b2a9f510.jpg";